import { render, staticRenderFns } from "./CSRActivities.vue?vue&type=template&id=1d17b1c2&scoped=true"
import script from "./CSRActivities.vue?vue&type=script&lang=js"
export * from "./CSRActivities.vue?vue&type=script&lang=js"
import style0 from "./CSRActivities.vue?vue&type=style&index=0&id=1d17b1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17b1c2",
  null
  
)

export default component.exports